export default __webpack_public_path__ + "static/media/goopter-goopter-process-diagram.ed5dd668.jpg";